<template>
  <div>
    <div class="con" v-if="!screenBool">
      <div class="img_item img_banner" >
        <el-image style="height:40px;width:75px;margin-left:calc(100vw * (360 / 1920);margin-top:30px" src="https://ui-repository.zhugen.tech/guanwang/logo.png" />
      </div>
      <div class="content">
        <div class="content_title">
          我们的服务
        </div>
        <div class="content_text" style="text-align:left">
          江苏竹根科技有限公司是中国优质的物联网解决方案服务商，专注于共享智能充电桩、智能门禁、智能门磁等领域的研发、设计、销售和运营。
        </div>
        <div class="content_row">
          <div class="content_serve">
            <div class="serve_header">自研</div>
            <div class="serve_text" style="text-align:left">
              壹充满™系列4G智能充电桩、守门神™系列4G智能门禁、5G NB-IoT智能门磁等产品和易登记、微网格、智慧表单等系统
            </div>
          </div>
          <div class="content_serve">
            <div class="serve_header">代理</div>
            <div class="serve_text" style="text-align:left">
              老人定位手环、油烟监控、燃气报警器等数十种产品
            </div>
          </div>
          <div class="content_serve">
            <div class="serve_header">定制</div>
            <div class="serve_text">
              个性化软件定制开发能力
            </div>
          </div>
        </div>
        <div class="content_title">
          最新产品
        </div>
        <div class="content_text">
          欢迎了解更多竹根物联网产品!
        </div>
        <div class="content_row">
          <div class="content_product">
            <div class="product_imgback">
              <img src="https://ui-repository.zhugen.tech/guanwang/图层 15.png" alt="">
            </div>
            <div class="product_title">两口智能充电桩</div>
          </div>
          <div class="content_product">
            <div class="product_imgback">
              <img src="https://ui-repository.zhugen.tech/guanwang/cp15.png" alt="">
            </div>
            <div class="product_title">刷卡式智能充电桩</div>

          </div>
          <div class="content_product">
            <div class="product_imgback">
              <img src="https://ui-repository.zhugen.tech/guanwang/图层 3.png" alt="">
            </div>
            <div class="product_title">NB智能门磁</div>
          </div>
          <div class="content_product">
            <div class="product_imgback">
              <img src="https://ui-repository.zhugen.tech/guanwang/sms.png" alt="">
            </div>
            <div class="product_title">智能门禁控制器</div>
          </div>
        </div>

        <div class="content_title">
          为什么选择竹根？
        </div>
        <div class="content_text" style="text-align:left">
          江苏竹根科技有限公司注册资金1000万元，总部位于江苏省无锡市，分公司有竹根新能源、竹根安防、竹根软件、竹根养老。我们的愿景使命：服务美好生活！
        </div>
        <div class="content_row">
          <div class="content_paper">
            <div class="paper_imgback">

              <el-image
                  class="img"
                  src="https://ui-repository.zhugen.tech/guanwang/图层 12.png"
                  @click="changeUrl('图层 12.png')"
                  :preview-src-list="srcList">
              </el-image>
            </div>
            <div class="paper_title">发明专利：一种基于OPENCPU方案的智能面板插座及其系统</div>
          </div>
          <div class="content_paper">
            <div class="paper_imgback">
              <el-image
                  class="img"
                  src="https://ui-repository.zhugen.tech/guanwang/图层 13.png"
                  @click="changeUrl('图层 13.png')"
                  :preview-src-list="srcList"
              ></el-image>
            </div>
            <div class="paper_title">发明专利：插座</div>
          </div>
        </div>
        <div class="content_row">
          <div class="content_paper2">
            <div class="paper2_img">
              <el-image
                  class="img"
                  src="https://ui-repository.zhugen.tech/guanwang/图层 8.png"
                  @click="changeUrl('图层 8.png')"
                  :preview-src-list="srcList"
              ></el-image>
              <el-image
                  class="img"
                  src="https://ui-repository.zhugen.tech/guanwang/图层 9.png"
                  @click="changeUrl('图层 9.png')"
                  :preview-src-list="srcList"
              ></el-image>
              <el-image
                  class="img"
                  src="https://ui-repository.zhugen.tech/guanwang/图层 10.png"
                  @click="changeUrl('图层 10.png')"
                  :preview-src-list="srcList"
              ></el-image>
              <el-image
                  class="img"
                  src="https://ui-repository.zhugen.tech/guanwang/图层 11.png"
                  @click="changeUrl('图层 11.png')"
                  :preview-src-list="srcList"
              ></el-image>
            </div>
            <div class="paper2_title">
              软件著作权登记证书
            </div>
          </div>
        </div>

        <div class="content_title">
          产品体验
        </div>
        <div class="content_row">
          <div class="content_app">

            <el-image
                class="img"
                src="https://ui-repository.zhugen.tech/guanwang/gate.png"
                @click="changeUrl('gate.png')"
                :preview-src-list="srcList"
            ></el-image>

          </div>
          <div class="content_app">

            <el-image
                class="img"
                src="https://ui-repository.zhugen.tech/guanwang/power.png"
                @click="changeUrl('power.png')"
                :preview-src-list="srcList"
            ></el-image>

          </div>
          <div class="content_app">

            <el-image
                class="img"
                src="https://ui-repository.zhugen.tech/guanwang/sign.png"
                @click="changeUrl('sign.png')"
                :preview-src-list="srcList"
            ></el-image>

          </div>
        </div>

        <div class="content_title">
          联系我们
        </div>
        <div class="content_text" style="text-align:left">
          <div class="con_label">联系方式：400-119-3365</div>
          <div class="con_label">公司地址：江苏省无锡市滨湖区滴翠路90号51004</div>
        </div>

      </div>
      <div class="con_bottom">
        <div class="con_bottom_company">
          ©2024 江苏竹根科技有限公司 版权所有
        </div>
        <div class="con_bottom_police">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021402001504"
             style="font-size: 12px;text-decoration:none;height:15px;line-height:14px">
            <img src="@/assets/police.png" style="float:left;height:13px"/>
            <p style="float:left;height:20px;margin: 0px 0px 0px 5px; color:#fff;">苏公网安备 32021402001504号</p></a>
          <a href="https://beian.miit.gov.cn/" style="font-size: 12px;text-decoration:none;height:15px;line-height:14px">
            <div style="color:#fff;margin-left:10px" >苏ICP备2021028898号-1</div>
          </a>
          <!-- <a target="_blank" href="https://xyt.xcc.cn/getpcInfo?sn=1539887339306713088&certType=8&url=*.zhugen.tech&language=CN"><img src="https://program.xinchacha.com/xyt/xcc_small_ssl.png" style="width:12px;highet:12px;margin-left:10px"></a> -->
        </div>

        <div class="con_xcc" style="position: absolute;right: 150px;">
          <a href="https://xyt.xcc.cn/getpcInfo?sn=1539865357274021888&language=CN&certType=8&url=*.zhugen.tech" target="_blank"
    style="position: relative;display: inline-block;height: 38px;">
    <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div><embed
      src="https://program.xinchacha.com/web/1539865357274021888=*.zhugen.tech.svg" width="103" height="38"
      type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/" />
  </a>
        </div>
      </div>
    </div>
    <div class="homeImg" v-if="screenBool">
      <img width="100%" style="display: block" src="@/assets/phone.jpg" alt="">
    </div>
  </div>


</template>

<script>
export default {
  data() {
    return {
       srcList:['https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg'],
      screenWidth:null,
      screenBool:true,
    };
  },
  mounted(){
    this.screenWidth = document.body.clientWidth
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  },

  watch: {
    screenWidth: {
      handler: function (val) {
        if (val < 750) {
          this.screenBool=true
          console.log(val+'屏幕宽度小于750px')
        } else {
          this.screenBool=false
          console.log(val+'屏幕宽度大于900px')
        }
      },
      immediate: true,
      deep:true
    },
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key,keyPath)
      this.keepaliveArr.push(key)
    },
    changeUrl(e){
      const name = "https://ui-repository.zhugen.tech/guanwang/"+e
      this.srcList=[name]
    }
  },
};
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
.con {

  width: 100%;
  /* height: calc(100vh - 60px); */
  overflow-x: hidden;
}

.img_item {
  width: 100%;
  height: 300px;
}

</style>
<style scoped>
   .homeImg{
     /*display: flex;*/
     /*align-items: center;*/
     /*justify-content: center;*/
     margin: 0 auto;
     width: 100vw;
     height: 100vh;

   }
@media screen and (min-width: 400px) {
  .img_item {
    width: 100vw;
    background: url("https://ui-repository.zhugen.tech/guanwang/banner.jpg");
    background-size: cover;
    height: calc(100vw * (640 / 1920));
    display: flex;
    flex-direction: column;
    /* align-items: flex-start; */
    justify-content: flex-start;
  }

   .img_banner{
    width: 100%;

   }
  .banner_title{
    font-size: calc(100vw * (100 / 1920));
    font-family: lixukexingshu;
    font-weight: 500;
    color: #FFFFFF;
  }
   .banner_title2{
    font-size: calc(100vw * (32 / 1920));
    font-family: lixukexingshu;
    font-weight: 500;
    color: #FFFFFF;
  }
  .content{
    margin: 0 auto;

    width: 80vw;
  }
  .content_title{
    font-size: 40px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
     width: 100%;
    margin: 58px 0;
    text-align: center;
  }

  .content_text{
    font-size: 16px;
    margin-bottom: 46px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    text-align: center;
  }
  .content_row{
    display: flex;
    width: 100%;
    justify-content: space-between;
    flex-wrap:wrap ;
  }
  .content_serve{
    width: calc((100% - 66px) / 3);
    height: 188px;
    border: 1px solid #E6E6E6;
  }
  .serve_header{
    width: calc(100vw * (80 / 1920));
    height: 38px;
    background: #1A7D3A;
    font-size: calc(100vw * (18 / 1920));
    color: #fff;
    line-height: 38px;
    text-align: center;
  }
  .serve_text{
    font-size: calc(100vw * (16 / 1920));
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1A7D3A;
    line-height: 26px;
    margin: 20px 20px 0 20px;
    text-align: center;
  }
  .content_product{
    width: calc((80vw - 97px) / 4);
  }
  .product_imgback{
    height: calc((80vw - 97px) / 4);
    height: calc((80vw - 97px) / 4);
    background:#F6F6F6  ;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .product_imgback img{
    height: 50%;
  }
  .product_title{
    text-align: center;
    margin-top: 24px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
  }
  .content_paper{
    width: calc((80vw - 114px) / 2);
    height: calc(((80vw - 114px) / 2) * (358 / 585));
    padding: 20px;
    border: 1px solid #E6E6E6  ;
  }
  .content_paper .img{
    width: 100%;
    height: calc(((80vw - 114px) / 2) * (250 / 444));
  }
  .paper_title{
    font-size: calc(100vw * (16 / 1920));
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1A7D3A;
    line-height: 26px;
    text-align: center;
  }
  .content_paper2{
    margin-top: 30px;
    width: 100%;
    height: calc(80vw * (398 / 1200));
    border: 1px solid #E6E6E6;
  }
  .paper2_img{
   padding: calc(80vw * (24 / 1200));
   width: calc(100% - (80vw * (48 / 1200)));
   display: flex;
   justify-content: space-between;
  }
  .paper2_img .img{
     width: calc(80vw * (224 / 1200));
     height: calc(80vw * (310 / 1200));
  }
  .paper2_title{
    text-align: center;
    font-size: calc(100vw * (16 / 1920)) ;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1A7D3A;
  }
  .con_bottom{
  margin-top: 126px;
  height: 64px;
  width: 100%;
  background: #15161A;
  display: flex;
  flex-direction:column ;
  justify-content: center;
  align-items: center;
  color: #fff;

}
.con_bottom_police{
  display: flex;
  font-size: 12px;
}
.content_app{
  width: calc((80vw - 120px) / 6);
  height: calc((80vw - 120px) / 6);
}
.content_app .img{
  height: 100%;
  width: 100%;
}
}
</style>
